// import config from 'config'
import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { RegistrationStatus } from '@/models/registration.models';

export const authService = {
  login,
  loginGoogle,
  loginFacebook,
  loginMicrosoft,
  loginApple,
  loginEcp,
  loginRouming,
  logout,
  register,
  registerGoogle,
  registerFacebook,
  registerMicrosoft,
  registerApple,
  registerEcp,
  registerRouming,
  resetPasswordRequest,
  resetPassword,
  changepass,
  confirmEmailRequest,
  confirmEmail,
  refreshtokem,
  personalDataGet,
  personalDataEdit,
  personalAvatarEdit,
  removeAccountRequest,
  removeAccountConfirm,
  restoreAccountRequest,
  restoreAccountConfirm,
  confirmEmailOrganisationUser,
  userSignsGet,
  userSignsDel,
  userSignsAdd,
  changeAccountToOrganization,
  checkConfirmEmailTokenValidity,
  checkConfirmEmailOrgUserTokenValidity,
  terminateConcurrentSession,
  getActiveSessions,
  getSession,
  markUserSessionAsSuspicious,
  addNewSignRequest,
  addNewSign,
  getAutoCreatedUserInfo,
  getRegistrationStatus,
  completeRegistration
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'Auth',
  get curLocation() {
    return window.location.origin;
  }
};

function extract(r) {
  return r.data;
}

async function refreshtokem(refreshToken) {
  return axios.post(`${model.baseUrl}${model.controller}/RefreshToken`, { refreshToken });
}

async function resetPasswordRequest(email, googleReCaptchaResponse, recaptchaType) {
  return axios.post(`${model.baseUrl}${model.controller}/ResetPasswordRequest`,
    { email, googleReCaptchaResponse, recaptchaType });
}

async function resetPassword(email, token, password, passwordconfirm, googleReCaptchaResponse, recaptchaType) {
  return axios.post(`${model.baseUrl}${model.controller}/ResetPassword`,
    { password, passwordconfirm, email, token, googleReCaptchaResponse, recaptchaType });
}
async function confirmEmailRequest(email, googleReCaptchaResponse, recaptchaType) {
  return axios.post(`${model.baseUrl}${model.controller}/ConfirmEmailRequest`,
    { email, googleReCaptchaResponse, recaptchaType }).then(extract);
}

async function confirmEmail(email, token, googleReCaptchaResponse, recaptchaType) {
  return axios.post(`${model.baseUrl}${model.controller}/ConfirmEmail`,
    { email, token, googleReCaptchaResponse, recaptchaType });
}

async function changepass(oldpassword, password, passwordconfirm) {
  return axios.post(`${model.baseUrl}${model.controller}/ChangePassword`, { oldpassword, password, passwordconfirm });
}

async function register(
  firstname,
  lastname,
  middlename,
  email,
  password,
  passwordconfirm,
  phonenumber,
  organization,
  googleReCaptchaResponse,
  registrationKey,
  initialUser,
  recaptchaType,
  referralToken: string = '',
  unregisteredUserToken: string = '') {
  return axios.post(`${model.baseUrl}${model.controller}/Register`,
    {
      firstname,
      lastname,
      middlename,
      email,
      password,
      passwordconfirm,
      phonenumber,
      organization,
      googleReCaptchaResponse,
      registrationKey,
      initialUser,
      recaptchaType,
      referralToken,
      unregisteredUserToken
    });
}
async function registerGoogle(
  code, organization, googleReCaptchaResponse, recaptchaType,
  registrationKey: string = '', referralToken: string = '', unregisteredUserToken: string = '') {
  return axios.post(`${model.baseUrl}${model.controller}/RegisterGoogle`,
    { code, organization, googleReCaptchaResponse, recaptchaType, registrationKey, referralToken, unregisteredUserToken });
}

async function registerFacebook(
  accessToken, organization, googleReCaptchaResponse, recaptchaType,
  registrationKey: string = '', referralToken: string = '', unregisteredUserToken: string = '') {
  return axios.post(`${model.baseUrl}${model.controller}/RegisterFacebook`,
    { accessToken, organization, googleReCaptchaResponse, recaptchaType, registrationKey, referralToken, unregisteredUserToken });
}

async function registerMicrosoft(
  accessToken, organization, googleReCaptchaResponse, recaptchaType,
  registrationKey: string = '', referralToken: string = '', unregisteredUserToken: string = '') {
  return axios.post(`${model.baseUrl}${model.controller}/RegisterMicrosoft`,
    { accessToken, organization, googleReCaptchaResponse, recaptchaType, registrationKey, referralToken, unregisteredUserToken });
}

async function registerApple(
  authorizationCode, appleUserUid, appleUser, organization, googleReCaptchaResponse,
  recaptchaType, registrationKey: string = '', referralToken: string = '', unregisteredUserToken: string = '') {
  return axios.post(`${model.baseUrl}${model.controller}/RegisterApple`,
    {
      authorizationCode,
      appleUserUid,
      appleUser,
      organization,
      googleReCaptchaResponse,
      recaptchaType,
      registrationKey,
      referralToken,
      unregisteredUserToken
    });
}

async function registerEcp(
  firstname,
  lastname,
  middlename,
  email,
  password,
  passwordconfirm,
  phonenumber,
  organization,
  googleReCaptchaResponse,
  sign,
  ecpSerial,
  recaptchaType,
  registrationKey: string = '',
  referralToken: string = '',
  unregisteredUserToken: string = '') {
  return axios.post(`${model.baseUrl}${model.controller}/RegisterEcp`,
    {
      firstname,
      lastname,
      middlename,
      email,
      password,
      passwordconfirm,
      phonenumber,
      organization,
      googleReCaptchaResponse,
      sign,
      ecpSerial,
      recaptchaType,
      registrationKey,
      referralToken,
      unregisteredUserToken
    });
}

async function registerRouming(id, code, password, passwordConfirm, googleReCaptchaResponse, recaptchaType) {
  return axios.post(`${model.baseUrl}${model.controller}/RegisterRouming`,
    { id, code, password, passwordConfirm, googleReCaptchaResponse, recaptchaType });
}

async function login(
  email, password, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint) {
  return axios.post(`${model.baseUrl}${model.controller}/Login`,
    { email, password, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint });
}
async function loginGoogle(code, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint) {
  return axios.post(`${model.baseUrl}${model.controller}/LoginGoogle`,
    { code, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint });
}
async function loginFacebook(
  accessToken, signedRequest, userID, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint) {
  return axios.post(`${model.baseUrl}${model.controller}/LoginFacebook`,
    { accessToken, signedRequest, userID, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint });
}
async function loginMicrosoft(accessToken, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint) {
  return axios.post(`${model.baseUrl}${model.controller}/LoginMicrosoft`,
    { accessToken, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint });
}
async function loginApple(authorizationCode, appleUserUid, appleUser, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint) {
  return axios.post(`${model.baseUrl}${model.controller}/LoginApple`,
    { authorizationCode, appleUserUid, appleUser, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint });
}
async function loginEcp(sign, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint) {
  return axios.post(`${model.baseUrl}${model.controller}/LoginEcp`,
    { sign, googleReCaptchaResponse, recaptchaType, pushNotificationToken, fingerPrint });
}
async function loginRouming(id, code, googleReCaptchaResponse, recaptchaType, fingerPrint) {
  return axios.post(`${model.baseUrl}${model.controller}/LoginRouming`,
    { id, code, googleReCaptchaResponse, recaptchaType, fingerPrint });
}

async function logout() {
  return axios.post(`${model.baseUrl}Auth/logout`);
}

async function personalDataGet() {
  return axios.get(`${model.baseUrl}Auth/PersonalDataGet`).then(extract);
}

async function userSignsGet() {
  return axios.get(`${model.baseUrl}Auth/UserSignsGet`).then(extract);
}

async function userSignsDel(userKeySerialCode) {
  return axios.delete(`${model.baseUrl}${model.controller}/UserSignsDel`, { data: { userKeySerialCode } });
}

async function userSignsAdd(sign) {
  return axios.put(`${model.baseUrl}${model.controller}/UserSignsAdd`, { sign });
}

async function personalDataEdit(firstname, lastname, middlename, phonenumber) {
  return axios.patch(`${model.baseUrl}${model.controller}/PersonalDataEdit`, { firstname, lastname, middlename, phonenumber });
}

async function personalAvatarEdit(avatar) {
  return axios.patch(`${model.baseUrl}${model.controller}/PersonalAvatarEdit`, avatar);
}

async function removeAccountRequest() {
  return axios.post(`${model.baseUrl}Auth/RemoveAccountRequest`);
}

async function removeAccountConfirm(
  token: string,
  email: string,
  googleReCaptchaResponse: string,
  recaptchaType: string) {
  return axios.post(`${model.baseUrl}Auth/RemoveAccount`,
    { token, email, googleReCaptchaResponse, recaptchaType });
}

async function restoreAccountRequest(email: string, googleReCaptchaResponse, recaptchaType) {
  return axios.post(`${model.baseUrl}Auth/RestoreAccountRequest`, { email, googleReCaptchaResponse, recaptchaType });
}

async function restoreAccountConfirm(
  email: string,
  token: string,
  password: string,
  passwordConfirm: string,
  googleReCaptchaResponse: string,
  recaptchaType: string) {
  return axios.post(`${model.baseUrl}Auth/RestoreAccount`,
    { email, token, password, passwordConfirm, googleReCaptchaResponse, recaptchaType });
}

async function confirmEmailOrganisationUser(
  email: string,
  token: string,
  password: string,
  passwordConfirm: string,
  googleReCaptchaResponse: string,
  recaptchaType: string) {
  return axios.post(`${model.baseUrl}Auth/ConfirmEmailOrgUser`,
    { email, token, password, passwordConfirm, googleReCaptchaResponse, recaptchaType });
}

async function changeAccountToOrganization(edrpou: string, organizationName: string, sign: string, typeUr: number) {
  return axios.post(`${model.baseUrl}${model.controller}/changeAccountToOrganization`, { edrpou, organizationName, sign, typeUr });
}

async function checkConfirmEmailTokenValidity(email, token, googleReCaptchaResponse, recaptchaType) {
  return axios
    .post(`${model.baseUrl}${model.controller}/CheckConfirmEmailTokenValidity`,
      { email, token, googleReCaptchaResponse, recaptchaType })
    .then(extract);
}

async function checkConfirmEmailOrgUserTokenValidity(email, token, googleReCaptchaResponse, recaptchaType) {
  return axios
    .post(`${model.baseUrl}${model.controller}/CheckConfirmEmailOrgUserTokenValidity`,
      { email, token, googleReCaptchaResponse, recaptchaType })
    .then(extract);
}

async function terminateConcurrentSession(sessionIds) {
  return axios
    .post(`${model.baseUrl}${model.controller}/TerminateConcurrentSession`,
      { sessionIds })
    .then(extract);
}

async function getActiveSessions() {
  return axios
    .get(`${model.baseUrl}${model.controller}/ActiveSessions`)
    .then(extract);
}

async function getSession(sessionId: string) {
  return axios
    .get(`${model.baseUrl}${model.controller}/GetSession?sessionId=${sessionId}`)
    .then(extract);
}

async function markUserSessionAsSuspicious(fingerPrint: string) {
  return axios
    .post(`${model.baseUrl}${model.controller}/MarkUserSessionAsSuspicious`,
      { fingerPrint })
    .then(extract);
}

async function addNewSignRequest(email, googleReCaptchaResponse, recaptchaType) {
  return axios.post(`${model.baseUrl}${model.controller}/AddNewSignRequest`,
    { email, googleReCaptchaResponse, recaptchaType });
}

async function addNewSign(email, token, sign, googleReCaptchaResponse, recaptchaType) {
  return axios.post(`${model.baseUrl}${model.controller}/AddNewSign`,
    { email, token, sign, googleReCaptchaResponse, recaptchaType });
}

async function getAutoCreatedUserInfo(email: string, googleReCaptchaResponse: string, recaptchaType: string) {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/GetAutoCreatedUserInfo`,
      { email, googleReCaptchaResponse, recaptchaType }
    )
    .then(extract);
}

function getRegistrationStatus(email, token, googleReCaptchaResponse, recaptchaType): Promise<RegistrationStatus> {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/GetRegistrationStatus`,
      { email, token, googleReCaptchaResponse, recaptchaType }
    )
    .then(r => new RegistrationStatus(r.data));
}

function completeRegistration(email: string, token: string, signature: string, lastName: string = '', firstName: string = '',
  googleReCaptchaResponse: string = '', recaptchaType: string = ''): Promise<boolean> {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/CompleteRegistration`,
      { email, token, signature, lastName, firstName, googleReCaptchaResponse, recaptchaType }
    )
    .then(extract);
}
